export default {
  submit: 'Einreichen',
  numberOfAtt: 'Teilnehmerzahl',
  email: 'E-Mail',
  phone: 'Telefonnummer',
  name: 'Deutsch',
  company: 'Unternehmen',
  welcome: 'Willkommen am Stand von Truking! Bitte füllen Sie Ihre Informationen aus, und wir senden Ihnen die gewünschten Produktunterlagen. Vielen Dank!',
  signIn: 'Eintragen',
  ctkj: 'Truking Technology Limited',
  zhCN: '中文',
  enUs: 'English',
  esEs: 'Español',
  deDe: 'Deutsch',
  ruRu: 'Русский язык',
  new_dept: 'Abteilung',
  new_title: 'Position',
  new_nation: 'Land',
  new_product: 'Produkttyp',
  requiredMsg: 'Bitte füllen Sie die erforderlichen Felder aus',
  successMsg: 'Erfolgreich eingereicht',
  new_tkproduct: 'Interessierte Produkte oder Lösungen'
}



// WEBPACK FOOTER //
// ./src/assets/lang/de-DE.js